<template>
	<div></div>
</template>

<script>
	export default{
		data(){
			return {
				
			}
		},
		beforeCreate(){
			console.log(this.$route.query);
			this.$router.push(this.$route.query.path);
		}
	}
</script>

<style>
</style>